import DynamicContent from "./DynamicContent/DynamicContent"
import { Container, useTheme } from "@material-ui/core"
import React from "react"
import { useParams } from "react-router-dom"

const DynamicContentPage = ({ type }) => {
    const { type: parameterType } = useParams()
    const theme = useTheme()
    // eslint-disable-next-line no-unneeded-ternary
    const selectedType = parameterType ?? type

    return (
        <main>
            <Container
                style={{
                    backgroundColor: theme.palette.background.default,
                    padding: theme.spacing(6),
                    paddingTop: theme.spacing(8),
                    minHeight: 600
                }}
            >
                <DynamicContent
                    type={selectedType}
                    style={{
                        maxWidth: 800
                    }}
                />
            </Container>
        </main>
    )
}

export default DynamicContentPage
